module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/preface#rpre",
      "id": "pre"
    }
  }, [_c('i', [_vm._v("Preface")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/int#rint",
      "id": "int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/part01#rpt1",
      "id": "pt1"
    }
  }, [_vm._v("PART I: U.S. EXCEPTIONALISM IN A CHANGING WORLD")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#rch1",
      "id": "ch1"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("  FROM EXCEPTIONALISM TO INTERNATIONALISM")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch02#rch2",
      "id": "ch2"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("  EXCEPTIONALISM AS THE CIVIC RELIGION")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#rch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("  THE ERA OF GLOBAL CONVERGENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#rch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("  EURASIA ON THE RISE, AMERICA ON THE SIDELINES")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#rch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("  RUSSIA–U.S. RELATIONS IN THE CHANGING WORLD ORDER")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02#rpt2",
      "id": "pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: AMERICA’S WARS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("  AMERICAN IMPERIALISM AND “WARS OF CHOICE”")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#rch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("  ENDING THE ISRAELI-PALESTINIAN CONFLICT")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch08#rch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("  NORTH KOREA AND THE DOOMSDAY CLOCK")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch09#rch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("  TRUMP’S NEW NATIONAL SECURITY STRATEGY")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part03#rpt3",
      "id": "pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: U.S. FOREIGN ECONOMIC STATECRAFT")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch10#rch10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v("  THE ECONOMIC BALANCE SHEET ON “AMERICA FIRST”")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch11#rch11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v("  FOREIGN POLICY POPULISM")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch12#rch12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v("  ECONOMIC WAR WITH CHINA")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch13#rch13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v("  WILL TRUMP HAND CHINA THE TECHNOLOGICAL LEAD?")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch14#rch14",
      "id": "ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v("  TOWARD A WORLD ECONOMY OF REGIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04#rpt4",
      "id": "pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: RENEWING AMERICAN DIPLOMACY")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch15#rch15",
      "id": "ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v("  FROM DIPLOMATIC LEADER TO ROGUE NATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch16#rch16",
      "id": "ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16")]), _vm._v("  THE ETHICS AND PRACTICALITIES OF FOREIGN AID")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch17#rch17",
      "id": "ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17")]), _vm._v("  MANAGING MIGRATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch18#rch18",
      "id": "ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("18")]), _vm._v("  ACHIEVING SUSTAINABLE DEVELOPMENT")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch19#rch19",
      "id": "ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("19")]), _vm._v("  A NEW FOREIGN POLICY FOR AMERICAN SECURITY AND WELL-BEING")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ack#rack",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/notes#rnt",
      "id": "nt",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/references#rref",
      "id": "ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("References")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/index#rind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0